export const addNewDefaultHistory = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const historiesRef = firebase.ref().child('histories');
        const newHistoryRef = historiesRef.push();
        newHistoryRef.set({
            'year' : '2200',
            'month' : '01',
            'content' : {
                'ko' : '새로운 연혁',
                'en' : 'New History'
            }
        }, () => {
            console.log('new history added')
        })
            .catch(e => {
                console.log(e);
            })
    }
}

export const updateHistory = ({ id, year, month, content }) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const historyRef = firebase.ref().child(`histories/${id}`); 
        console.log(month);

        const toUpdate =  (month === null || month === '') ? {
                'year': year,
                'content': content
            } : {
                'year' : year,
                'content' : content,
                'month' : month
            };

        historyRef.set(toUpdate, () => {
        })
            .catch(e => {
                console.log(e);
            })
    }
}

export const removeHistory = (id) => {
    return (dispatch, getState, getFirebase) => {
        const result = global.confirm('정말로 삭제하시겠습니까?');
        if(result) {
            const firebase = getFirebase();
            const historyRef = firebase.ref().child(`histories/${id}`); 
            historyRef.remove( () => {
            })
                .catch(e => {
                    console.log(e);
                })
        }
    }
}

export const newEmptyArticleAdded = (id) => {
    return {
        type : 'NEW_EMPTY_ARTICLE_ADDED',
        payload : {
            id
        }
    }
}

export const startAddNewArticle = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const articlesRef = firebase.ref().child('articles');
        const newArticleRef = articlesRef.push();
        newArticleRef.set({
            title : '',
            subTitle : '',
            category : 'news',
            view : 0,
        }, () => {
            dispatch(newEmptyArticleAdded(newArticleRef.key));
        })
    } 
}
export const deleteAddedNewArticle = (id, imageCount) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const articleRef = firebase.ref().child(`articles/${id}`);
        articleRef.remove()
            .then(() => {
                const storage = firebase.storage();    
                for(let i = 0; i < imageCount; ++i) {
                    const articleRef = storage.ref(`article_images/${id}_${i}.jpg`);
                    articleRef.delete();
                }
            })
            .catch((e) => {
            })
    } 
}

export const deleteArticle = (id, imageCount) => {
    return (dispatch, getState, getFirebase) => {
        const result = global.confirm('정말로 삭제하시겠습니까?')
        if(result) {
            const firebase = getFirebase();
            const articleRef = firebase.ref().child(`articles/${id}`);
            articleRef.remove( () => {
                const storage = firebase.storage();
                const articleHTMLRef = storage.ref(`articles/${id}.html`);
                articleHTMLRef.delete()
                    .then(() => {
                        for(let i = 0; i < imageCount; ++i) {
                            const articleeImageRef = storage.ref(`article_images/${id}_${i}.jpg`);
                            articleeImageRef .delete();
                        }
                    })
                    .catch((e) => {
                    })
            })
                .catch((e) => {
                    console.log(e);
                })
        }
    } 
}

export const updateArticle = ({ id, category, title, subTitle, text, imageCount, date }) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const articleRef = firebase.ref().child(`articles/${id}`);
        articleRef.update({
            category,
            title, 
            subTitle, 
            imageCount,
            date
        }, ()=>{
            const storage = firebase.storage();
            const articleHTMLRef = storage.ref(`articles/${id}.html`);
            articleHTMLRef.delete()
                .then(()=>{
                    const task = articleHTMLRef.putString(text);
                    task.on('state_changed', 
                        (snapshot)=> {
                        },
                        (e) => {
                        },
                        ()=>{
                        })
                })
                .catch((e)=>{
                })
        })
            .catch((e) => {
                console.log(e)
            })
    }
}

export const addNewArticleSuccess = () => {
    return { type : 'ADD_NEW_ARTICLE_SUCCESS' }
}

export const addNewArticle = ({id, category, title, subTitle, text, imageCount, date}) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const articleRef = firebase.ref().child(`articles/${id}`);
        articleRef.set({
            category,
            title,
            subTitle,
            imageCount : imageCount,
            date,
            view : 0,
        }, 
            ()=>{
                dispatch(addNewArticleSuccess());
                const storage = firebase.storage();
                const articlesRef = storage.ref(`articles/${id}.html`);
                const task = articlesRef.putString(text);
                task.on('state_changed',
                    (snapshot)=>{
                    },
                    (e) => {
                    },
                    ()=>{
                    })
            })
            .catch(e => {
            })
    }
}

export const deleteUnusedImages = (storagePath, id, imageIds) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const storage = firebase.storage();

        for(let i = 0; i < imageIds.length; ++i) {
            const imageRef = storage.ref(`${storagePath}/${id}_${imageIds[i]}.jpg`);
            imageRef.delete()
                .then(() => {
                })
                .catch((e) => {
                    console.log(e);
                })
        }
    }
}

export const homepageDataOrderSwitch = (dbPath, aIndex, bIndex) => {
    return (dispatch, getState, getFirebase) => {

        const firebase = getFirebase();
        const dataArray = getState().admin.homepage[dbPath];

        if(aIndex < 0 || aIndex > dataArray.length - 1 ||
            bIndex < 0 || bIndex > dataArray.length - 1) { 
                return;
        }

        let aData = {...dataArray[aIndex]};
        const aId = aData.id;

        let bData = {...dataArray[bIndex]};
        const bId = bData.id;

        delete aData['id'];
        delete bData['id'];

        const newAOrder = bData.order;
        const newBOrder = aData.order;

        aData.order= newAOrder;
        bData.order = newBOrder;


        const dataArrayRef = firebase.ref().child(`${dbPath}/`);
        dataArrayRef.update({
            [aId] : {
                ...aData
            },
            [bId] : {
                ...bData
            }
        })
    }
}

export const addNewDefaulHomepageData = (dbPath) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const datas  = getState().admin.homepage[dbPath];

        const datasRef = firebase.ref().child(`${dbPath}/`);
        const newDataRef = datasRef.push();
        newDataRef.set({
            title : {
                en : 'New Data',
                ko : '새로운 데이터'
            }, content : {
                en : 'New Content',
                ko : '내용입니다'
            },
            'order' : datas.length,
        }, () => {
        })
        .catch(e => {
        })
    }
}
export const updateHomepageData = (dbPath, id, title, content) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const dataRef = firebase.ref().child(`${dbPath}/${id}`); 
        dataRef.update({
            title,
            content
        }, () => {
        })
        .catch(e => {
            console.log(e);
        })
    }
}
export const removeHomepageData = (dbPath, storagePath, id) => {
    return (dispatch, getState, getFirebase) => {
        const result = global.confirm('정말로 삭제하시겠습니까?')
        if(result) {
            const firebase = getFirebase();

            const homepageRef = firebase.ref().child(`${dbPath}`);
            const itemRef = firebase.ref().child(`${dbPath}/${id}`); 

            itemRef.remove( () => {
                let dep = getState()['admin']['homepage'][`${dbPath}`];
                for(let i = 0; i < dep.length; ++i) {
                    homepageRef.child(`${dep[i].id}`).update({order : i });
                }


            })
                .catch(e => {
                    console.log(e);
                })
            const imageRef = firebase.storage().ref(`${storagePath}/${id}.jpg`);
            imageRef.delete()
                .then(() => {
                })
                .catch((e) => {
                    console.log(e);
                })
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/actions/homepageActions.js